/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { track } from '../../analytics';
import './educational-info.style.scss';

const EducationalInfo = ({
  link = null, title, shortDescription, multiView = false
}) => {
  const renderLink = () => {
    if (!link) return null;
    const { url = '/', text = '' } = link;
    return (
      <div className="educational-info__link">
        <a href={url} onClick={() => track({ location: 'link', text })}>{text}</a>
      </div>
    );
  };

  const containerClasses = classNames('educational-info__container', {
    'educational-info__container--desktop': !multiView,
    'educational-info__container--multi-view': multiView,
    'sui-flex sui-flex-col': true
  });
  const educationalInfo = classNames('educational-info');

  return (
    <div className={educationalInfo}>
      <div className={containerClasses}>
        <div className="educational-info__title">{title}</div>
        <div className="educational-info__description">{shortDescription}</div>
        {link && renderLink()}
      </div>
    </div>
  );
};

EducationalInfo.propTypes = {
  link: PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string
  }),
  shortDescription: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  multiView: PropTypes.bool
};

export { EducationalInfo };
